module.exports = __webpack_public_path__ + "img/dialog_bg.edd7984d.png";